module.exports = __webpack_public_path__ + "static/img/gif1.0cf523d4.gif";